import { createContext } from 'react';
import { useFiltersContext } from '../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_SAMU,
    useChartsData
} from '../../../../Common/hooks/useChartsData';
import { getUserSession } from '../../../../../../util/core/Session';
import config from '../../../../../../config/config';

export const SectorizationChartsDataContext = createContext();

const SectorizationChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const session = getUserSession();
    const profile = session?.user?.application_profile_id;
    const isAdm = profile === config.default_foreign_key.profiles.zellusAdmin;

    const filterParams = {
        ano: filters.ano?.value,
        ...(filters.mes?.value && { mes: filters.mes.value }),
        ...(isAdm && filters.cidade?.value && { city: filters.cidade.value })
    };

    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SAMU.SECTORIZATION_RESULTS,
            url: 'governanceroom/dashboardsamu/results/sectorization'
        },
        filterParams
    );

    const chartData = data
        ? {
            sectorizationByNeighborhoodMonthly: data?.sectorizationByNeighborhoodMonthly ?? [],
          }
        : {
              sectorizationByNeighborhoodMonthly: []
          };

    return (
        <SectorizationChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </SectorizationChartsDataContext.Provider>
    );
};

export default SectorizationChartsDataProvider;
